import { render, staticRenderFns } from "./optionsDetail.vue?vue&type=template&id=61719542&scoped=true"
import script from "./optionsDetail.vue?vue&type=script&lang=js"
export * from "./optionsDetail.vue?vue&type=script&lang=js"
import style0 from "./optionsDetail.vue?vue&type=style&index=0&id=61719542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61719542",
  null
  
)

export default component.exports